export enum OperationOutcomeEnum {
  PROCESSED = "PROCESSED",
  FAILED = "FAILED",
}
